import WebdienstFooterDemo from '../WebdienstFooterDemo';
import { WebdienstTemplateCode } from '../codeHighlights/WebdienstTemplateCode';
import WebdienstHeader from '../nav/WebdienstHeader';

const WebdienstTemplate = () => {
  return (
    <>
      <WebdienstHeader />
      <div className="container mt-5">
        <div className="row">
          <div className="col-12">
            <h1>Title</h1>
            <p className="lead">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta
              magni incidunt quos ex! Veniam accusamus ad harum suscipit ipsa,
              voluptas ipsum eligendi quisquam quis aspernatur iure. Nisi sequi
              esse eveniet.
            </p>
          </div>
        </div>
        <WebdienstFooterDemo />
      </div>
      <div className="mt-5">
        <WebdienstTemplateCode />
      </div>
    </>
  );
};

export default WebdienstTemplate;
